import 'moment-timezone';
import { getBalance } from '@ally/transfer-account-utils';
import { validator } from '@ally/validator';
import { ClosingFee } from '../../../constants';
var DoesNotExceedDistributionAmount = function (amount, _a) {
    var fromAccount = _a.fromAccount, values = _a.values;
    // If no distribution amount provided, skip validation
    if (!values.distributionAmountType)
        return true;
    return fromAccount !== null && amount + ClosingFee <= getBalance(fromAccount);
};
export var DoesNotExceedDistributionErrorMessage = "You need to leave at least $".concat(ClosingFee, " in your account to cover potential fees.");
export var DoesNotExceedDistributionAmountValidator = validator(DoesNotExceedDistributionAmount, DoesNotExceedDistributionErrorMessage);
//# sourceMappingURL=DoesNotExceedDistributionAmount.js.map